"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PRODUCT_LIST_PATHS = void 0;
exports.applyScrollPosition = applyScrollPosition;
exports.captureScrollPosition = captureScrollPosition;
exports.productListScrollBehavior = productListScrollBehavior;
exports.readScrollPositionForPath = readScrollPositionForPath;
exports.restoreScrollPositionForPath = restoreScrollPositionForPath;
exports.saveScrollPositionForPath = saveScrollPositionForPath;
var PRODUCT_LIST_PATHS = exports.PRODUCT_LIST_PATHS = ['/product/index', '/pointsStore/index', '/leaseProduct/index'];
var storageKey = function storageKey(path) {
  return "product_list_scroll_".concat(path);
};
function captureScrollPosition() {
  var appMain = document.querySelector('.app-main');
  return {
    appMainScroll: appMain ? appMain.scrollTop : 0,
    windowScroll: document.documentElement.scrollTop || document.body.scrollTop || 0
  };
}
function applyScrollPosition(pos) {
  if (!pos) return;
  var appMain = document.querySelector('.app-main');
  if (appMain) {
    appMain.scrollTop = pos.appMainScroll || 0;
  }
  var y = pos.windowScroll || 0;
  document.documentElement.scrollTop = y;
  document.body.scrollTop = y;
}
function saveScrollPositionForPath(path) {
  if (!path) return;
  sessionStorage.setItem(storageKey(path), JSON.stringify(captureScrollPosition()));
}
function readScrollPositionForPath(path) {
  if (!path) return null;
  try {
    var raw = sessionStorage.getItem(storageKey(path));
    return raw ? JSON.parse(raw) : null;
  } catch (e) {
    return null;
  }
}
function restoreScrollPositionForPath(path) {
  applyScrollPosition(readScrollPositionForPath(path));
}
function productListScrollBehavior(to, from, savedPosition) {
  if (PRODUCT_LIST_PATHS.includes(to.path)) {
    var pos = readScrollPositionForPath(to.path);
    if (pos) {
      return new Promise(function (resolve) {
        setTimeout(function () {
          applyScrollPosition(pos);
          resolve({
            x: 0,
            y: pos.windowScroll || 0
          });
        }, 600);
      });
    }
  }
  if (savedPosition) {
    return savedPosition;
  }
  return {
    x: 0,
    y: 0
  };
}